import { render } from "./Uhoh.vue?vue&type=template&id=51c7ba78"
import script from "./Uhoh.vue?vue&type=script&lang=js"
export * from "./Uhoh.vue?vue&type=script&lang=js"

import "./Uhoh.vue?vue&type=style&index=0&id=51c7ba78&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__